import * as React from "react"
import cx from "classnames"

import Header from "./header"
import Footer from "./footer"
import Banner from "./banner"

import "@fontsource/inter/400.css"
import "@fontsource/inter/500.css"
import "@fontsource/inter/700.css"

import "@styles/main.scss"
import styles from "./layout.module.scss"

const Layout = ({ headerFill, hasSpace, headerDark, children }) => {
  if (typeof window !== "undefined") {
    require("smooth-scroll")('a[href*="#"]')
  }

  return (
    <>
      <Header headerFill={headerFill} headerDark={headerDark} />
      <main
        className={cx(styles.main, {
          [styles.hasSpace]: hasSpace,
        })}
      >
        {children}
      </main>
      <Footer />
      <Banner />
    </>
  )
}

export default Layout
